import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import CustomReport from '../entity/CustomReport';

export const startFetchingCustomReports = () =>
  produce((draft: Draft<State>) => {
    draft.customReport.fetching = draft.customReport.fetching + 1;
  });

export const setCustomReports = (customReport: CustomReport) =>
  produce((draft: Draft<State>) => {
    draft.customReport.data = customReport;
  });

export const finishFetchingCustomReports = () =>
  produce((draft: Draft<State>) => {
    draft.customReport.fetching = draft.customReport.fetching - 1;
  });

export const disposeCustomReports = () =>
  produce((draft: Draft<State>) => {
    draft.customReport.data = initialState.customReport.data;
    draft.customReport.fetching = initialState.customReport.fetching;
  });
